import { useState, useEffect } from "react";
import { Card, Row, Col, Table, Button, Modal, Badge, Spinner } from "react-bootstrap";
import api from "../../../services/api";
import { FaPlus, FaEdit } from "react-icons/fa";
import { getCurrentUser } from '../../../common/utils'; 
import OcorrenciasEdit from "./OcorrenciasEdit";
import Paginacao from '../../../common/pagination'; 

const Ocorrencias = () => {
    const [ocorrencias, setOcorrencias] = useState({}); 
    const [loadingData, setLoadingData] = useState(true);
    const [pageNumb, setPageNumb] = useState(1); 
    
    const [showModal, setShowModal] = useState(false);
    const [editingId, setEditingId] = useState(null);
    
    const dados_usuario = getCurrentUser();
    const programa_id = dados_usuario['ambiente_programa_id'];

    useEffect(() => {
        listarOcorrencias(1);
    }, []);

    const listarOcorrencias = async (pagina = 1) => {
        setLoadingData(true);
        try {
            const response = await api.get(`/ocorrencias/?programa_id=${programa_id}&page=${pagina}`);
            setOcorrencias(response.data);
            setPageNumb(pagina);
        } catch (error) {
            console.error("Erro ao listar ocorrências", error);
        } finally {
            setLoadingData(false);
        }
    };

    const handlePageChange = (num_page) => {
        listarOcorrencias(num_page);
    };

    const handleNew = () => {
        setEditingId(null); 
        setShowModal(true);
    };

    const handleEdit = (id) => {
        setEditingId(id); 
        setShowModal(true);
    };

    const onSaveSuccess = () => {
        setShowModal(false);
        listarOcorrencias(pageNumb);
    };

    return (
        <div className="container-fluid">
            <Row className="align-items-center mb-4 mt-3">
                <Col>
                    <h4 className="page-title">Histórico de Ocorrências</h4>
                </Col>
                <Col className="text-end">
                    <Button variant="secondary" onClick={handleNew}>
                        <FaPlus className="me-2" /> Nova Ocorrência
                    </Button>
                </Col>
            </Row>

            <Card className="cardDestaque border-0 shadow-sm">
                <Card.Body>
                    {loadingData ? (
                        <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
                    ) : (
                        <>
                            <Table responsive className="custom-table">
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Médico</th>
                                        <th>Origem / Via</th>
                                        <th>Patologia</th>
                                        <th>Descrição</th>
                                        <th className="text-end">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(!ocorrencias.results || ocorrencias.results.length === 0) && (
                                        <tr><td colSpan="6" className="text-center text-muted">Nenhuma ocorrência registrada.</td></tr>
                                    )}
                                    {ocorrencias.results && ocorrencias.results.map((oc) => (
                                        <tr key={oc.id}>
                                            <td>{new Date(oc.data).toLocaleString()}</td>
                                            <td className="fw-bold">{oc.medico_nome}</td>
                                            <td>
                                                <Badge bg="secondary" className="me-1">{oc.origem_nome}</Badge>
                                                <Badge bg="info">{oc.via_nome}</Badge>
                                            </td>
                                            <td>{oc.patologia_nome || '-'}</td>
                                            <td className="text-truncate" style={{maxWidth: '250px'}} title={oc.descricao}>{oc.descricao}</td>
                                            <td className="text-end">
                                                <Button variant="outline-primary" size="sm" onClick={() => handleEdit(oc.id)}>
                                                    <FaEdit />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            
                            {ocorrencias.results && ocorrencias.results.length > 0 && (
                                <Paginacao 
                                    dados={ocorrencias} 
                                    loading={loadingData} 
                                    page_numb={pageNumb} 
                                    _onClickPagina={handlePageChange} 
                                />
                            )}
                        </>
                    )}
                </Card.Body>
            </Card>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{editingId ? 'Editar' : 'Registrar'} Ocorrência</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OcorrenciasEdit 
                        id={editingId} 
                        programa_id={programa_id} 
                        onSuccess={onSaveSuccess} 
                        onCancel={() => setShowModal(false)}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Ocorrencias;
